// ==========================================
// frontend/src/pages/Realizations.jsx
import React, { useEffect, useState, useCallback } from "react";
//import { Link } from "react-router-dom";
import { getRealizations, getCategories } from "../services/api";
import ImageZoom from "../components/ImageZoom";
import {
  //FaArrowRight,
  FaCalendar,
  FaUser,
} from "react-icons/fa";

const Realizations = () => {
  const [realizations, setRealizations] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    try {
      const params = { published: true };
      if (selectedCategory) params.category = selectedCategory;

      const [realizationsRes, categoriesRes] = await Promise.all([
        getRealizations(params),
        getCategories(),
      ]);

      setRealizations(realizationsRes.data);
      setCategories(categoriesRes.data);
    } catch (error) {
      console.error("Erreur:", error);
    } finally {
      setLoading(false);
    }
  }, [selectedCategory]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="py-12 bg-gray-50 min-h-screen">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            Nos Réalisations
          </h1>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Découvrez nos projets récents et nos success stories
          </p>
        </div>

        {/* Filtres par catégorie */}
        {categories.length > 0 && (
          <div className="mb-8 flex flex-wrap gap-4 justify-center">
            <button
              onClick={() => setSelectedCategory("")}
              className={`px-6 py-2 rounded-lg font-semibold transition-colors ${
                selectedCategory === ""
                  ? "bg-blue-600 text-white"
                  : "bg-white text-gray-700 hover:bg-gray-100"
              }`}
            >
              Tous
            </button>
            {categories.map((category) => (
              <button
                key={category._id}
                onClick={() => setSelectedCategory(category._id)}
                className={`px-6 py-2 rounded-lg font-semibold transition-colors ${
                  selectedCategory === category._id
                    ? "bg-blue-600 text-white"
                    : "bg-white text-gray-700 hover:bg-gray-100"
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        )}

        {/* Grille des réalisations */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {realizations.map((realization) => (
            <div
              key={realization._id}
              className="bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden"
            >
              <ImageZoom
                src={`${
                  process.env.REACT_APP_API_URL ||
                  "https://api.seengineering-tn.com"
                }${realization.image}`}
                alt={realization.title}
                className="h-70 object-cover"
              />
              <div className="p-6">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-xl font-bold text-gray-800">
                    {realization.title}
                  </h3>
                  {realization.category && (
                    <span className="px-3 py-1 bg-blue-100 text-blue-600 text-sm rounded-full">
                      {realization.category.name}
                    </span>
                  )}
                </div>

                <div className="flex items-center gap-4 mb-3 text-sm text-gray-600">
                  {realization.client && (
                    <div className="flex items-center gap-1">
                      <FaUser size={12} />
                      <span>{realization.client}</span>
                    </div>
                  )}
                  {realization.date && (
                    <div className="flex items-center gap-1">
                      <FaCalendar size={12} />
                      <span>
                        {new Date(realization.date).toLocaleDateString("fr-FR")}
                      </span>
                    </div>
                  )}
                </div>

                <p className="text-gray-600 mb-4 line-clamp-3">
                  {realization.description}
                </p>

                {realization.technologies &&
                  realization.technologies.length > 0 && (
                    <div className="mb-4 flex flex-wrap gap-2">
                      {realization.technologies
                        .slice(0, 3)
                        .map((tech, index) => (
                          <span
                            key={index}
                            className="px-2 py-1 bg-gray-100 text-gray-700 text-xs rounded"
                          >
                            {tech}
                          </span>
                        ))}
                    </div>
                  )}

                {/* <Link
                  to={`/realizations`}
                  className="text-blue-600 hover:text-blue-700 font-semibold inline-flex items-center gap-2"
                >
                  Voir le projet
                  <FaArrowRight size={14} />
                </Link> */}
              </div>
            </div>
          ))}
        </div>

        {realizations.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-600 text-lg">
              Aucune réalisation trouvée dans cette catégorie.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Realizations;
